<template>
    <div>
        <pt-sub-title title="历史订单"></pt-sub-title>
          <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber" :page-size="pageSize" ref="table" :refresh="false">
            <wt-table :list="tableData" :labels="tableLabels">
							<template>
								<el-table-column label="是否续存">
									<template slot-scope="scope">
										{{ scope.row.extendInfo&&scope.row.extendInfo.renewFlg==='Y'?'是':"否" }}
									</template>
								</el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" @click="orderDetail(scope.row)">订单详情</el-button>
                        <el-button type="text" v-if="scope.row.type === 'CONTRACT'" @click="handleDelete(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
							</template>
            </wt-table>
          </wt-paged-table>
    </div>
</template>
<script>
import { getEnumeration } from 'enumeration'
export default {
  props: {
    pageSize: {
      type: Number,
      default: 10
    },
    id: {
      type: String,
      default: ''
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  computed: {
    goodsTypeList () {
      return this.$store.state.goodsTypeList || []
    }
  },
  data () {
    return {
      totalNumber: 0,
      tableData: []
    }
  },
  methods: {
    getTableData (page, next) {
      let data = {
        example: {
          userId: this.id
        },
        pageable: {
          page: page,
          size: this.pageSize
        }
      }
      this.$store.dispatch('getMallOrders', data).then(res => {
        this.totalNumber = res.totalNumber
        this.tableData = res.data
        if (this.goodsTypeList.length > 0) {
          this.getOrderGoodsType()
        } else {
          this.getGoodsTypes()
        }
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$message.error(err || '查询订单列表失败')
      })
    },
    getGoodsTypes () {
      return this.$store.dispatch('getGoodsTypes').then(_ => {
        this.$nextTick(_ => {
          this.getOrderGoodsType()
        })
      })
    },
    // 获取订单商品的枚举值
    getOrderGoodsType () {
      this.tableData.forEach(item => {
        let goodsItem = (item.goods && item.goods[0]) || {}
        this.$set(item, 'goods_type', goodsItem.type && getEnumeration(goodsItem.type, this.goodsTypeList, 'name'))
      })
    },
    orderDetail (row) {
      this.$router.push('/mall-order-all/order-detail/' + row.id + '/detail')
    },
    // 删除订单（仅CONTRACT类型）
    handleDelete (row) {
      this.$confirm('您确定删除该订单吗？删除后无法恢复。', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(_ => {
        this.$store.dispatch('deleteMallOrder', row.id).then(res => {
          this.$message.success('删除成功')
          this.getTableData(0)
        }).catch(err => {
          this.$message.error(err || '删除失败')
        })
      }).catch(_ => {})
    }
  },
  created () {
  }
}
</script>
<style lang="less">

</style>
